const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const articleModelActions = require('client-v2/common/models/article/actions')

function mapDispatchToProps(dispatch) {
  const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onAddClick: dispatchAuthRequiredAction(
      articleModelActions.handleArticleAddAction,
      authModalActions.showSignup
    ),
    onContentClick: dispatchAction(articleModelActions.navigateToArticleContent),
    onDomainClick: dispatchAction(articleModelActions.navigateToArticleDomainSearch),
    onMoreActionsClick: dispatchAuthRequiredAction(
      articleModelActions.showArticleActionsModal,
      authModalActions.showSignup
    ),
    onShareClick: dispatchAction(articleModelActions.showArticleShareModal)
  }
}

module.exports = {
  mapDispatchToProps
}
